import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import './infobox.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from "@fortawesome/fontawesome-svg-core";


function InfoBox({ title, cases, total, color, active, type, pop, icon, country, ...props }) {
  console.log(country);  
  return (
        <Card
          onClick={props.onClick}
          className={`infoBox ${active && "infoBox--selected infoBox--"}${color}`}
        >
          <div className={color}>
             <a href={country === `worldwide` ? `https://www.worldometers.info/coronavirus/` : `https://www.worldometers.info/coronavirus/country/${country}/`}>
                <CardContent>
                  <FontAwesomeIcon icon={icon} color={color} size="lg"/>
                  <Typography color="textSecondary" gutterBottom>
                    <h2>{title}</h2>
                  </Typography>
                    <h2 className={`infoBox__cases--${color}`}>
                    +{cases}
                    </h2>  
                  <Typography className="infoBox__total" color="textSecondary">
                    <p>{total} Total</p>
                
                  </Typography>
                </CardContent>
              </a>
          </div>
        </Card>
    );
  }
  
export default InfoBox;